/**
 * Status de envio do formulário de atendimento (tabelas do catálogo support_center_forms).
 * Extraído para evitar ciclo appointments ↔ attend.
 */
import { supabase } from '../lib/supabase'
import { supportCenterFormsService } from './supportCenterForms'

export async function loadAttendanceFormStatusByIds(appointmentIds: string[]): Promise<{
  submittedIds: Set<string>
  draftIds: Set<string>
}> {
  const submittedIds = new Set<string>()
  const draftIds = new Set<string>()
  if (appointmentIds.length === 0) {
    return { submittedIds, draftIds }
  }

  const forms = await supportCenterFormsService.list()
  const tables = [
    ...new Set(
      forms
        .map((form) => form.table_name?.trim())
        .filter((name): name is string => Boolean(name))
    ),
  ]

  for (const table of tables) {
    const { data, error } = await supabase
      .from(table)
      .select('id, submitted_at')
      .in('id', appointmentIds)

    if (error) {
      // Tabela cadastrada mas ausente no banco — ignora e segue.
      if (error.code === '42P01' || /does not exist/i.test(error.message)) {
        continue
      }
      throw error
    }

    for (const row of data ?? []) {
      const id = String((row as { id?: string }).id ?? '')
      if (!id) continue
      const submittedAt = (row as { submitted_at?: string | null }).submitted_at
      if (submittedAt) {
        submittedIds.add(id)
      } else {
        draftIds.add(id)
      }
    }
  }

  return { submittedIds, draftIds }
}

/** true se alguma tabela de formulário tiver submitted_at para o agendamento. */
export async function isAttendanceFormSubmitted(appointmentId: string): Promise<boolean> {
  const id = appointmentId.trim()
  if (!id) return false
  const { submittedIds } = await loadAttendanceFormStatusByIds([id])
  return submittedIds.has(id)
}
